import Vue from "vue";
import Router from "vue-router";
import home from "@/components/home";
import eventcenter from "@/components/eventcenter";
import detail from "@/components/detail";
import release from "@/components/release";
import center from "@/components/center";
import register from "@/components/register";
import wishlist from "@/components/wishlist";
import orginazation from "@/components/orginazation";
import orginazationdetail from "@/components/orginazationdetail";
import applywish from "@/components/applywish";
import policy from "@/components/policy";
import policydetail from "@/components/policydetail";
import sjzd from "@/components/sjzd";
import searchresult from "@/components/searchresult";
import newsdetail from "@/components/newsdetail";
import infochange from "@/components/infochange";
import createorg from "@/components/createorg";
import mail from "@/components/mail";
import maildetail from "@/components/maildetail";
import myfav from "@/components/myfav";
import cfshow from "@/components/cfshow";
import homepage from "@/components/homepage";
import topic from "@/components/topic";
import myjf from "@/components/myjf";
import jfrank from "@/components/jfrank";
import sjdetail from "@/components/sjdetail";
import resentzx from "@/components/resentzx";
import resenthd from "@/components/resenthd";
import daohang from "@/components/daohang";
import createevent from "@/components/createevent";
import hourslog from "@/components/hourslog";
import addevent from "@/components/addevent";
import eventcenterdetail from "@/components/eventcenterdetail";
import mywish from "@/components/mywish";
import myjoin from "@/components/myjoin";
import honor from "@/components/honor";
import wishcheck from "@/components/wishcheck";
import mywishlist from "@/components/mywishlist";
import onlinelearn from "@/components/onlinelearn";
import wishrate from "@/components/wishrate";
import jfcenter from "@/components/jfcenter";
import jfrecord from "@/components/jfrecord";
import jfrecorddetail from "@/components/jfrecorddetail";
import jfgoodsdetail from "@/components/jfgoodsdetail";
import zhengshulist from "@/components/zhengshulist";
import zhengshudetail from "@/components/zhengshudetail";
import detailqr from "@/components/detailqr";
import fangyi from "@/components/fangyi";
import fylyb from "@/components/fylyb";
import yqfktg from "@/components/yqfktg";
import fyzx from "@/components/fyzx";
import fykp from "@/components/fykp";
import fybgt from "@/components/fybgt";
import fyxlyz from "@/components/fyxlyz";
import organizationcheck from "@/components/organizationcheck";
import signlist from "@/components/signlist";
import checkdetail from "@/components/checkdetail";

const originalReplace = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalReplace.call(this, location).catch(err => err);
};
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: home,
      meta: {
        title: "江阴市新时代文明实践云平台"
      }
    },
    {
      path: "/eventcenter",
      name: "eventcenter",
      component: eventcenter,
      meta: {
        title: "“澄”就微心愿"
      }
    },
    {
      path: "/detail",
      name: "detail",
      component: detail,
      meta: {
        title: "活动详情",
        requireAuth: true,
        needin: true
      }
    },
    {
      path: "/release",
      name: "release",
      component: release,
      meta: {
        title: "发布报告",
        requireAuth: true
      }
    },
    {
      path: "/center",
      name: "center",
      component: center,
      meta: {
        title: "我的家园",
        requireAuth: true
      }
    },
    {
      path: "/register",
      name: "register",
      component: register,
      meta: {
        title: "注册加入"
      }
    },
    {
      path: "/wishlist",
      name: "wishlist",
      component: wishlist,
      meta: {
        title: "心愿列表",
        requireAuth: true
      }
    },
    {
      path: "/orginazation",
      name: "orginazation",
      component: orginazation,
      meta: {
        title: "志愿组织"
      }
    },
    {
      path: "/orginazationdetail",
      name: "orginazationdetail",
      component: orginazationdetail,
      meta: {
        title: "志愿组织详情"
      }
    },
    {
      path: "/applywish",
      name: "applywish",
      component: applywish,
      meta: {
        title: "发布心愿"
      }
    },
    {
      path: "/policy",
      name: "policy",
      component: policy,
      meta: {
        title: "实践政策"
      }
    },
    {
      path: "/policydetail",
      name: "policydetail",
      component: policydetail,
      meta: {
        title: "详情"
      }
    },
    {
      path: "/sjzd",
      name: "sjzd",
      component: sjzd,
      meta: {
        title: "实践阵地"
      }
    },
    {
      path: "/searchresult",
      name: "searchresult",
      component: searchresult,
      meta: {
        title: "搜索结果"
      }
    },
    {
      path: "/newsdetail",
      name: "newsdetail",
      component: newsdetail,
      meta: {
        title: "新闻详情"
      }
    },
    {
      path: "/infochange",
      name: "infochange",
      component: infochange,
      meta: {
        title: "个人信息",
        requireAuth: true
      }
    },
    {
      path: "/createorg",
      name: "createorg",
      component: createorg,
      meta: {
        title: "志愿组织入驻",
        requireAuth: true
      }
    },
    {
      path: "/mail",
      name: "mail",
      component: mail,
      meta: {
        title: "通知",
        requireAuth: true
      }
    },
    {
      path: "/maildetail",
      name: "maildetail",
      component: maildetail,
      meta: {
        title: "详情",
        requireAuth: true
      }
    },
    {
      path: "/myfav",
      name: "myfav",
      component: myfav,
      meta: {
        title: "我的收藏"
        //requireAuth:true,
      }
    },
    {
      path: "/cfshow",
      name: "cfshow",
      component: cfshow,
      meta: {
        title: "澄风show",
        keepAlive: true
      }
    },
    {
      path: "/homepage",
      name: "homepage",
      component: homepage,
      meta: {
        title: "个人主页",
        requireAuth: true
      }
    },
    {
      path: "/topic",
      name: "topic",
      component: topic,
      meta: {
        title: "话题页"
      }
    },
    {
      path: "/myjf",
      name: "myjf",
      component: myjf,
      meta: {
        title: "我的积分",
        requireAuth: true
      }
    },
    {
      path: "/jfrank",
      name: "jfrank",
      component: jfrank,
      meta: {
        title: "积分排行",
        requireAuth: true
      }
    },
    {
      path: "/sjdetail",
      name: "sjdetail",
      component: sjdetail,
      meta: {
        title: "实践阵地详情"
      }
    },
    {
      path: "/resentzx",
      name: "resentzx",
      component: resentzx,
      meta: {
        title: "近期资讯"
      }
    },
    {
      path: "/resenthd",
      name: "resenthd",
      component: resenthd,
      meta: {
        title: "近期活动"
      }
    },
    {
      path: "/daohang",
      name: "daohang",
      component: daohang,
      meta: {
        title: "导航"
      }
    },
    {
      path: "/createevent",
      name: "createevent",
      component: createevent,
      meta: {
        title: "创建活动",
        requireAuth: true
      }
    },
    {
      path: "/hourslog",
      name: "hourslog",
      component: hourslog,
      meta: {
        title: "服务时长日志",
        requireAuth: true
      }
    },
    {
      path: "/addevent",
      name: "addevent",
      component: addevent,
      meta: {
        title: "创建活动",
        requireAuth: true
      }
    },
    {
      path: "/eventcenterdetail",
      name: "eventcenterdetail",
      component: eventcenterdetail,
      meta: {
        title: "活动中心"
      }
    },
    {
      path: "/mywish",
      name: "mywish",
      component: mywish,
      meta: {
        title: "我的许愿列表",
        requireAuth: true
      }
    },
    {
      path: "/myjoin",
      name: "myjoin",
      component: myjoin,
      meta: {
        title: "我的许愿列表",
        requireAuth: true
      }
    },
    {
      path: "/honor",
      name: "honor",
      component: honor,
      meta: {
        title: "志愿榜单"
      }
    },
    {
      path: "/wishcheck",
      name: "wishcheck",
      component: wishcheck,
      meta: {
        title: "许愿进度查看",
        requireAuth: true
      }
    },
    {
      path: "/mywishlist",
      name: "mywishlist",
      component: mywishlist,
      meta: {
        title: "我能发布报告的活动列表"
      }
    },
    {
      path: "/onlinelearn",
      name: "onlinelearn",
      component: onlinelearn,
      meta: {
        title: "在线学习"
      }
    },
    {
      path: "/wishrate",
      name: "wishrate",
      component: wishrate,
      meta: {
        title: "心愿点评"
      }
    },
    {
      path: "/jfcenter",
      name: "jfcenter",
      component: jfcenter,
      meta: {
        title: "积分兑换",
        requireAuth: true
      }
    },
    {
      path: "/jfrecord",
      name: "jfrecord",
      component: jfrecord,
      meta: {
        title: "兑换记录",
        requireAuth: true
      }
    },
    {
      path: "/jfrecorddetail",
      name: "jfrecorddetail",
      component: jfrecorddetail,
      meta: {
        title: "兑换记录",
        requireAuth: true
      }
    },
    {
      path: "/jfgoodsdetail",
      name: "jfgoodsdetail",
      component: jfgoodsdetail,
      meta: {
        title: "详情",
        requireAuth: true
      }
    },
    {
      path: "/zhengshulist",
      name: "zhengshulist",
      component: zhengshulist,
      meta: {
        title: "我的证书",
        requireAuth: true
      }
    },
    {
      path: "/zhengshudetail",
      name: "zhengshudetail",
      component: zhengshudetail,
      meta: {
        title: "证书详情",
        requireAuth: true
      }
    },
    {
      path: "/detailqr",
      name: "detailqr",
      component: detailqr,
      meta: {
        title: "活动详情",
        requireAuth: true
      }
    },
    {
      path: "/fangyi",
      name: "fangyi",
      component: fangyi,
      meta: {
        title: "疫情“解忧杂货铺”"
      }
    },
    {
      path: "/fylyb",
      name: "fylyb",
      component: fylyb,
      meta: {
        title: "新时代文明实践云平台留言板"
      }
    },
    {
      path: "/yqfktg",
      name: "yqfktg",
      component: yqfktg,
      meta: {
        title: "疫情防控通告"
      }
    },
    {
      path: "/fyzx",
      name: "fyzx",
      component: fyzx,
      meta: {
        title: "疫情资讯"
      }
    },
    {
      path: "/fykp",
      name: "fykp",
      component: fykp,
      meta: {
        title: "防疫科普"
      }
    },
    {
      path: "/fybgt",
      name: "fybgt",
      component: fybgt,
      meta: {
        title: "曝光台"
      }
    },
    {
      path: "/fyxlyz",
      name: "fyxlyz",
      component: fyxlyz,
      meta: {
        title: "心理援助"
      }
    },
    {
      path: "/organizationcheck",
      name: "organizationcheck",
      component: organizationcheck,
      meta: {
        title: "组织审核",
        requireAuth: true
      }
    },
    {
      path: "/signlist",
      name: "signlist",
      component: signlist,
      meta: {
        title: "签到签离",
        requireAuth: true
      }
    },
    {
      path: "/checkdetail",
      name: "checkdetail",
      component: checkdetail,
      meta: {
        title: "个人信息",
        requireAuth: true
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js